import { mainInfoService } from "../../services/api";

interface MainInfo {
  name: string;
  text: string;
}

let mainInfoList: MainInfo[] = [
  {
    name: "recruitmentPhone",
    text: "(098) 210 210 1",
  },
  {
    name: "cvsPhone",
    text: "(050) 085 44 73",
  },
  {
    name: "pressEmail",
    text: "210polk.army@gmail.com",
  },

  {
    name: "feedbackEmail",
    text: "210polk.army@gmail.com",
  },

  {
    name: "applicationEmail",
    text: "210polk.army@gmail.com",
  },
  {
    name: "supportLink",
    text: "https://send.monobank.ua/jar/5GYiMqhCAM",
  },
  {
    name: "subscriptionLink",
    text: "https://send.monobank.ua/jar/5GYiMqhCAM",
  },
];

export async function loadMainInfo() {
  try {
    // Call the API to get all patronat info entries
    const response = await mainInfoService.getAll();

    // Extract the data from the response
    const newMainInfoList: MainInfo[] = response.data;

    // Sort by name before storing
    mainInfoList = newMainInfoList.sort((a, b) => a.name.localeCompare(b.name));

    return mainInfoList;
  } catch (error) {
    console.error("Failed to load info:", error);
    throw new Error("Не вдалося завантажити інформацію");
  }
}

// Create function
export async function createMainInfo(data: { name: string; text: string }) {
  try {
    const response = await mainInfoService.create(data);

    // Reload the list to get the updated data
    await loadMainInfo();

    return response.data;
  } catch (error) {
    console.error("Failed to create info:", error);
    if (error.response?.status === 409) {
      throw new Error("Запис з такою назвою вже існує");
    }
    throw new Error("Не вдалося створити запис");
  }
}

// Update function
export async function updateMainInfo(name: string, data: { text: string }) {
  try {
    const response = await mainInfoService.update(name, data);

    // Reload the list to get the updated data
    await loadMainInfo();

    return response.data;
  } catch (error) {
    console.error("Failed to update info:", error);
    if (error.response?.status === 404) {
      throw new Error("Запис не знайдено");
    }
    throw new Error("Не вдалося оновити запис");
  }
}

// Delete function
export async function deleteMainInfo(name: string) {
  try {
    const response = await mainInfoService.delete(name);

    // Reload the list to get the updated data
    await loadMainInfo();

    return response.data;
  } catch (error) {
    console.error("Failed to delete info:", error);
    if (error.response?.status === 404) {
      throw new Error("Запис не знайдено");
    }
    throw new Error("Не вдалося видалити запис");
  }
}

export function getMainInfoByName(name: string) {
  return mainInfoList.find((item) => item.name == name)?mainInfoList.find((item) => item.name == name).text : undefined;
}
